const viewportBreakpoints = {
  XSS: 370,
  XS: 412,
  SIDEBAR_BOTTOM: 640,
  MOBILE: 766,
  TABLET: 1024
};

export { viewportBreakpoints };
//# sourceMappingURL=breakpoints.js.map
